<template>
  <!-- Dropdown: Tipo de liga -->
  <b-dropdown
    variant="link"
    no-caret
    toggle-class="p-0"
    right
  >
    <!-- Tipo de liga seleccionada -->
    <template
      #button-content
    >
      <label>
        {{ tipoSelected.label }}
        <feather-icon
          icon="ChevronDownIcon"
          size="16"
          class="align-middle"
        />
      </label>
    </template>

    <!-- Tipo de ligas disponibles -->
    <b-dropdown-item
      v-for="urlType in availableUrlTypes"
      :key="urlType.tipo"
      @click="tipoSelected = urlType; $emit('add-url-type', urlType.tipo)"
    >
      <feather-icon
        :icon="urlType.icon"
        class="mr-50"
      />
      <span>{{ urlType.label }}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import {
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import useNotificationComponse from '../useNotificationComponse'

export default {
  components: {
    BDropdown,
    BDropdownItem,
  },
  setup(_, { emit }) {
    const tipoSelected = ref({ tipo: 1, label: 'Liga externa', icon: 'ExternalLinkIcon' })
    const { availableUrlTypes } = useNotificationComponse()

    onMounted(() => emit('add-url-type', 1))

    const resetComponent = () => {
      tipoSelected.value = { tipo: 1, label: 'Liga externa', icon: 'ExternalLinkIcon' }
    }

    return {
      availableUrlTypes,
      tipoSelected,
      resetComponent,
    }
  },
}
</script>
